/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Studyprograms_Study_Empirical_Linguistics26Inputs */

const en__field__enum_studyprograms_study_empirical_linguistics26 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Empirical_Linguistics26Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empirical Linguistics`)
};

const de__field__enum_studyprograms_study_empirical_linguistics26 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Empirical_Linguistics26Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empirische Sprachwissenschaften`)
};

/**
* | output |
* | --- |
* | "Empirical Linguistics" |
*
* @param {_Field__Enum_Studyprograms_Study_Empirical_Linguistics26Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_studyprograms_study_empirical_linguistics26 = /** @type {((inputs?: _Field__Enum_Studyprograms_Study_Empirical_Linguistics26Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Studyprograms_Study_Empirical_Linguistics26Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_studyprograms_study_empirical_linguistics26(inputs)
	return de__field__enum_studyprograms_study_empirical_linguistics26(inputs)
});
export { _field__enum_studyprograms_study_empirical_linguistics26 as "_field__enum_studyPrograms_STUDY_EMPIRICAL_LINGUISTICS" }